const Email = ({ size = 40, onClick }) => (
  <svg
    id="Email"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    onClick={onClick}
  >
    <g clip-path="url(#clip0_1847_2423)">
      <path
        d="M18.8602 31.2941C25.1871 31.2941 30.3161 26.1652 30.3161 19.8382C30.3161 13.5113 25.1871 8.38232 18.8602 8.38232C12.5333 8.38232 7.4043 13.5113 7.4043 19.8382C7.4043 26.1652 12.5333 31.2941 18.8602 31.2941Z"
        fill="#80D4DC"
      />
      <path
        d="M30.4764 26.7549C30.014 26.7549 29.6382 26.3791 29.6382 25.9166C29.6382 25.4542 30.014 25.0784 30.4764 25.0784C35.3284 25.0784 36.3231 22.6168 36.3231 18.9202C36.3231 13.8083 33.9858 12.7619 30.4764 12.7619C30.014 12.7619 29.6382 12.3861 29.6382 11.9237C29.6382 11.4613 30.014 11.0854 30.4764 11.0854C33.7064 11.0854 37.9996 11.8971 37.9996 18.9202C37.9996 25.9432 33.7064 26.7549 30.4764 26.7549Z"
        fill="#5A348C"
      />
      <path
        d="M22.2983 32.7314C21.882 32.7314 21.5215 32.4213 21.4671 31.998C21.4098 31.5383 21.7353 31.1192 22.1935 31.062C24.9625 30.7127 26.9701 29.8521 28.1603 28.5025C29.1564 27.3737 29.6412 25.8621 29.6412 23.8825V14.1366C29.6412 10.7543 28.9441 8.27452 27.5107 6.55474C25.7937 4.49548 23.0094 3.49379 18.9971 3.49379C14.9847 3.49379 12.2004 4.49548 10.4848 6.55474C9.0514 8.27452 8.35427 10.7543 8.35427 14.1366V23.9886L8.35846 25.9152C8.35846 26.1373 8.27044 26.3511 8.11397 26.5089C7.9561 26.6668 7.74375 26.7548 7.52022 26.7548C4.29022 26.7548 -0.00292969 25.9431 -0.00292969 18.9201C-0.00292969 12.3497 3.75515 11.2153 6.88316 11.0966C7.22405 8.78165 7.98963 6.92915 9.19529 5.4818C11.2252 3.04812 14.5223 1.81592 18.9999 1.81592C23.4774 1.81592 26.7745 3.04812 28.8002 5.4804C30.4948 7.51452 31.3191 10.345 31.3191 14.1352V23.8811C31.3191 26.2868 30.6974 28.1617 29.4191 29.6104C27.9299 31.2981 25.6359 32.3165 22.4045 32.7245C22.3696 32.7286 22.3332 32.7314 22.2983 32.7314ZM6.71831 12.7856C2.55927 13.0511 1.67633 15.4372 1.67633 18.9201C1.67633 23.6114 3.64478 24.88 6.68338 25.056L6.68059 23.99V14.1366C6.68059 13.6728 6.69316 13.2215 6.71831 12.7856Z"
        fill="#5A348C"
      />
      <path
        d="M18.9205 36.0788C16.6363 36.0788 14.7769 34.2207 14.7769 31.9352C14.7769 29.6496 16.6349 27.7915 18.9205 27.7915C21.2061 27.7915 23.0642 29.6496 23.0642 31.9352C23.0642 34.2207 21.2061 36.0788 18.9205 36.0788ZM18.9205 29.4694C17.5598 29.4694 16.4533 30.5758 16.4533 31.9366C16.4533 33.2973 17.5598 34.4038 18.9205 34.4038C20.2813 34.4038 21.3877 33.2973 21.3877 31.9366C21.3877 30.5758 20.2813 29.4694 18.9205 29.4694Z"
        fill="#5A348C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1847_2423">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Email;
